import type { ReleaseT } from '../types'

const release: ReleaseT = {
  usefulContent: {
    description: 'React Native 0.61 includes Fast Refresh and more.',
    links: [
      {
        title:
          'Official blog post about the major changes on React Native 0.61',
        url: 'https://facebook.github.io/react-native/blog/2019/09/18/version-0.61',
      },
      {
        title: '[External] Tutorial on upgrading to React Native 0.61',
        url: 'https://reactnative.thenativebits.com/courses/upgrading-react-native/upgrade-to-react-native-0.61/',
      },
    ],
  },
}

export default release
